const initialState = {
    isOpen: false,
    isActive: false,
    story: {},
};
const initialData = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_VIDEO':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default initialData;
